export default "__VITE_ASSET__92QwHmFe__"